import React from "react";

function Password() {
  return <div>Password</div>;
}

export default Password;
